export default __webpack_public_path__ + "static/media/StarterSolenoids.633d55c9.pdf";